import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Navbar from 'components/Navbar';
import UserCard from 'components/Steps/UserCard';
import { UserProfileWrapper } from './styles';

class UserProfile extends Component {
  componentDidMount() {
    const {
      literals,
      setBreadcrumb,
    } = this.props;
    const breadcrumb = [
      {
        color: '#ffffff',
        text: literals.userProfile,
      },
    ];

    setBreadcrumb(breadcrumb.slice());
  }

  render() {
    const { color, match: { params: { id } } } = this.props;

    return (
      <UserProfileWrapper color={color}>
        <Navbar />
        <UserCard color={color} user={{ id }} />
      </UserProfileWrapper>
    );
  }
}

UserProfile.propTypes = {
  literals: PropTypes.object.isRequired,
  setBreadcrumb: PropTypes.func.isRequired,
  color: PropTypes.string.isRequired,
  match: PropTypes.object.isRequired,
};

export default UserProfile;



// WEBPACK FOOTER //
// ./src/routes/UserProfile/components/UserProfile.jsx